// components
import { styled, Box, BoxProps } from '@mui/material';
import { Drawer } from 'components/shared';

export const StyledTopMatchInfoContainer = styled(Box)<BoxProps>(
  ({ theme }) => ({
    backgroundColor: theme.vars.palette.surface.bright,
    margin: theme.spacing(0, -5),
    padding: theme.spacing(5, 6),
    display: 'flex',
    gap: theme.spacing(4)
  })
);
export const StyledLargeDrawerPaper = styled(Drawer)(({ theme }) => ({
  '& .MuiPaper-root': {
    width: '85%',
    borderTopLeftRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: theme.shape.borderRadius
  }
}));
